export default function createNetworkMetrics() {
    if (window.navigator.connection) {
        const networkMetrics = {
            network_downlink: window.navigator.connection.downlink,
            network_effective_type: window.navigator.connection.effectiveType,
            network_rtt: window.navigator.connection.rtt,
            network_save_data: !!window.navigator.connection,
        };
        return networkMetrics;
    }
}
